import { ComponentType, lazy } from 'react';
import { AiFillSignal, AiOutlineRocket } from 'react-icons/ai';
import { BiLike } from 'react-icons/bi';
import { BsFillShieldLockFill } from 'react-icons/bs';
import { CgHeadset } from 'react-icons/cg';
import { FaUserEdit } from 'react-icons/fa';
import { FiActivity, FiCast, FiDatabase, FiRadio, FiSun, FiYoutube } from 'react-icons/fi';
import {
  HiOutlineDocumentReport,
  HiOutlineLightBulb,
  HiOutlineShoppingCart,
  HiOutlineUsers
} from 'react-icons/hi';
import { IoBrowsersOutline, IoPulseSharp, IoTerminalOutline } from 'react-icons/io5';
import {
  MdAutoGraph,
  MdEmail,
  MdOutlineAdsClick,
  MdOutlineCampaign,
  MdOutlineFactCheck,
  MdOutlineFeed,
  MdOutlineInsights,
  MdOutlineLocalShipping,
  MdOutlineNotificationsActive,
  MdOutlinePersonPinCircle,
  MdOutlineReceipt,
  MdOutlineScience,
  MdOutlineTimeline,
  MdPlaylistAdd
} from 'react-icons/md';
import {
  RiBarChartBoxLine,
  RiBillLine,
  RiBuilding2Line,
  RiCalendarLine,
  RiDashboardLine,
  RiDatabaseLine,
  RiDeviceLine,
  RiFlowChart,
  RiGitBranchLine,
  RiGridLine,
  RiGroupLine,
  RiHeartPulseLine,
  RiImageAddLine,
  RiLayoutMasonryLine,
  RiLockLine,
  RiMagicLine,
  RiNodeTree,
  RiPaletteLine,
  RiPlayLine,
  RiPlugLine,
  RiRefund2Line,
  RiRobot2Line,
  RiRssLine,
  RiRulerLine,
  RiSettingsLine,
  RiSlideshow2Line,
  RiSlideshowLine,
  RiStoreLine,
  RiTestTubeLine,
  RiTimeLine,
  RiToggleLine,
  RiTrophyLine,
  RiTvLine,
  RiUserAddLine
} from 'react-icons/ri';
import { TbShoppingCartSearch } from 'react-icons/tb';
import { TiArrowRepeat, TiMortarBoard } from 'react-icons/ti';
import { VscBellDot, VscDebug } from 'react-icons/vsc';
import { Navigate, useParams } from 'react-router-dom';
import { COMMERCE_OPS } from '@blisspointmedia/bpm-types/dist/CommerceOps';
import {
  AUDIO,
  COMMERCE,
  CROSS_CHANNEL,
  DISPLAY,
  EMAIL,
  LINEAR,
  PROGRAMMATIC,
  RADIO,
  SEARCHSHOPPING,
  SOCIAL,
  STREAMING,
  YOUTUBE
} from '@blisspointmedia/bpm-types/dist/ScpChannels';
import { Role } from '@blisspointmedia/bpm-types/dist/Users';
import { PAGE_NAMES } from '@Components/Page/page-constants';
import { ActiveOTT } from '@Pages/ActiveOTT';
import { Admin } from '@Pages/Admin';
import {
  LinearAdOps,
  StreamingAdOps,
  StreamingUnresolvedMappings,
  StreamingValidatePlacement
} from '@Pages/AdOps';
import { AgentOrderApproval } from '@Pages/AgentOrderApproval';
import { AlexaVisibility } from '@Pages/AlexaVisibility';
import { AmcInstances } from '@Pages/AmcInstances';
import { AnomalyDetection } from '@Pages/AnomalyDetection';
import { ApiSentry } from '@Pages/ApiSentry';
import { BatchFailures } from '@Pages/BatchFailures';
import { BillingAutomation } from '@Pages/BillingAutomation';
import { BrandEquity } from '@Pages/BrandEquity';
import { BrandHealthMetrics } from '@Pages/BrandHealthMetrics/BrandHealthMetrics';
import { Calendar } from '@Pages/Calendar';
import { CampaignAudit } from '@Pages/CampaignAudit';
import { ChartsPage } from '@Pages/Charts/ChartsPage';
import { ClientConfig } from '@Pages/ClientConfig';
import { ClientDataMapping, GlobalDataMapping } from '@Pages/ClientDataMapping';
import { ClientProfitabilitySurvey } from '@Pages/ClientProfitabilitySurvey';
import { CommerceAdOps } from '@Pages/CommerceAdOps';
import { CommerceOps } from '@Pages/CommerceOps';
import { CommerceScraper } from '@Pages/CommerceScraper';
import { Companies } from '@Pages/Companies';
import { CompetitiveMetrics } from '@Pages/CompetitiveMetrics';
import { CompetitiveSpots } from '@Pages/CompetitiveSpots';
import { CopyTiger } from '@Pages/CopyTiger/CopyTiger';
import { CreditMemos } from '@Pages/CreditMemos';
import { CroOnboard } from '@Pages/CroOnboard';
import { CrossChannel } from '@Pages/CrossChannel';
import { CrossClientOracleChat } from '@Pages/CrossClientOracleChat';
import { CustomerInsights } from '@Pages/CustomerInsights';
import { DagGraphs } from '@Pages/DagGraphs';
import { DagStart } from '@Pages/DagStart';
import { DagStatus } from '@Pages/DagStatus';
import { DashboardPage } from '@Pages/Dashboard/DashboardPage';
import { DataConnectorTool } from '@Pages/DataConnectorTool';
import { DataFreshness } from '@Pages/DataFreshness';
import { DeviceBreakout } from '@Pages/DeviceBreakout';
import { DigitalAudit } from '@Pages/DigitalAudit';
import { FeedManagement } from '@Pages/FeedManagement';
import { Finance } from '@Pages/Finance';
import { FiscalCalendarInputPage } from '@Pages/FiscalCalendarInput';
import { GeoMMM } from '@Pages/GeoMMM';
import { GeoResponse } from '@Pages/GeoResponse';
import { GoalIntake } from '@Pages/GoalIntake';
import { GoalIntakeNew } from '@Pages/GoalIntakeNew';
import { GoogleAdsAudit } from '@Pages/GoogleAdsAudit';
import { HROAS } from '@Pages/HROAS';
import { IconLocalLinearMappings } from '@Pages/IconLocalLinearMappings';
import { IncrementalityPlaybook } from '@Pages/IncrementalityPlaybook';
import { InsightsAgent } from '@Pages/InsightsAgent';
import { Invoicing } from '@Pages/Invoicing';
import { KpiMapping } from '@Pages/KpiMapping';
import { KpiSetup } from '@Pages/KpiSetup';
import { KPIStatus } from '@Pages/KPIStatus';
import { LinearConstraints } from '@Pages/LinearConstraints';
import { LinearCpms } from '@Pages/LinearCpms';
import { LinearNetworks } from '@Pages/LinearNetworks';
import { LinearPacing } from '@Pages/LinearPacing';
import { MetaHackathon } from '@Pages/MetaHackathon';
import { CommerceMmm, DtcCommerceMmm, GeoMmmNew, RmmmCommerce, RmmmDtc } from '@Pages/MMM';
import { DataQA } from '@Pages/MMM/DataQA/DataQA';
import { FeatureMapping } from '@Pages/MMM/FeatureMapping/FeatureMapping';
import { Newton } from '@Pages/Newton';
import { OracleChat } from '@Pages/OracleChat';
import { OracleClientConfig } from '@Pages/OracleClientConfig';
import { ClientConfigTab } from '@Pages/OracleClientConfig/oracle-client-config-constants';
import { Pacing } from '@Pages/Pacing';
import { PaidSearchAudit } from '@Pages/PaidSearchAudit';
import { PlaceholderPage } from '@Pages/PlaceholderPage';
import { LogsTracker } from '@Pages/LogsTracker';
import { ProcessLogs } from '@Pages/ProcessLogs';
import { ProductRoadmap } from '@Pages/ProductRoadmap';
import { QueryExporter } from '@Pages/QueryExporter';
import { ReferenceDocs } from '@Pages/ReferenceDocs';
import { Reporting } from '@Pages/Reporting';
import { SegmentationMapping } from '@Pages/SegmentationMapping';
import { SignalDashboard } from '@Pages/SignalDashboard';
import { SiteMonitoring } from '@Pages/SiteMonitoring';
import { SlideGenerator } from '@Pages/SlideGenerator';
import { SlideGeneratorAdmin } from '@Pages/SlideGeneratorAdmin';
import { SotGa4MappingTool } from '@Pages/SotGa4MappingTool';
import { SpikeChart } from '@Pages/SpikeChart';
import { StreamingBuying } from '@Pages/StreamingBuying';
import { StreamingConstraints } from '@Pages/StreamingConstraints';
import { StreamingCreatives } from '@Pages/StreamingCreatives';
import { StreamingDiscrepancies } from '@Pages/StreamingDiscrepancies';
import { DisplayPacingPage, StreamingPacingPage } from '@Pages/StreamingPacing';
import { StreamingFlightPlan } from '@Pages/StreamingFlightPlan/StreamingFlightPlan';
import { StreamingMediaPlanner } from '@Pages/StreamingMediaPlanner';
import { StreamingNetworks } from '@Pages/StreamingNetworks';
import { StreamingOptimizations } from '@Pages/StreamingOptimizations';
import { StreamingOrderStatus } from '@Pages/StreamingOrderStatus';
import { StreamingWizard } from '@Pages/StreamingWizard';
import { SystemHealth } from '@Pages/SystemHealth';
import { UserAdmin } from '@Pages/UserAdmin';
import { CreativeInsights } from '@Pages/CreativeInsights';
import { WebTrafficOptimization } from '@Pages/WebTrafficOptimization';
import { ActivityFeed } from '@src/Pages/ActivityFeed/ActivityFeed';
import { ActivityFeedClient } from '@src/Pages/ActivityFeed/ActivityFeedClient';
import {
  AGENTIC_PLATFORM_FLAG,
  AGENTIC_PLATFORM_KEY,
  AGENTIC_PLATFORM_TITLE
} from '@src/Pages/AgenticPlatform/agentic-platform-constants';
import { AmcInsights } from '@src/Pages/AmcInsights';
import { CategoryPathingDemo } from '@src/Pages/CategoryPathing';
import { ClientAssociations } from '@src/Pages/ClientAssociations';
import { ElevateDemo } from '@src/Pages/ElevateDemo';
import { AgentPlanBuy } from '@src/Pages/AgentPlanBuy';
import { FeatureExperiments } from '@src/Pages/FeatureExperiments';
import { ForecastingPage } from '@src/Pages/Forecasting';
import { ScalingPage } from '@src/Pages/Forecasting/SaturationCurve/ScalingPage';
import { GlobalBenchmarking } from '@src/Pages/GlobalBenchmarking';
import { LinearBuying } from '@src/Pages/LinearBuying';
import { LinearBuyingAssignments } from '@src/Pages/LinearBuyingAssignments';
import { LinearMLDiagnostics } from '@src/Pages/LinearMLDiagnostics';
import { LinearOptimizations } from '@src/Pages/LinearOptimizations';
import { LinearOrders } from '@src/Pages/LinearOrders';
import { LinearPlans } from '@src/Pages/LinearPlans';
import { MetaFatigueInsights } from '@src/Pages/MetaFatigueInsights';
import { RetailOpsChannels } from '@src/Pages/RetailOpsChannels';
import { ShopifyConnections } from '@src/Pages/ShopifyConnections';
import { StreamingMLDiagnostics } from '@src/Pages/StreamingMLDiagnostics';
import { StreamingReports } from '@src/Pages/StreamingReports';
import { TikTokShopAuth } from '@src/Pages/TikTokShopAuth';
import { XClientBenchmarking } from '@src/Pages/XClientBenchmarking';
import { YouTubePlanning } from '@src/Pages/YouTubePlanning';
import {
  AudioSingleChannel,
  CommerceSingleChannel,
  DisplaySingleChannel,
  EmailSingleChannel,
  LinearSingleChannel,
  ProgrammaticSingleChannel,
  RadioSingleChannel,
  SearchShoppingSingleChannel,
  SocialSingleChannel,
  StreamingSingleChannel,
  YoutubeSingleChannel
} from '@src/Pages/SingleChannel/Channels/SingleChannelFactory';
import { useLocationCompany } from '../hooks/useLocationCompany';
import CrossChannelIcon from './assets/CrossChannelIcon.svg?react';
import TVADCrossChannel from './assets/TVADCrossChannelIcon.svg?react';
import {
  BpmLocation,
  INTERNAL_TOOLS_TERTIARY_KEY,
  InternalToolsSectionKey,
  LocationType,
  NavGroup,
  NavGroupKey
} from './location-constants';

// Lazy-loaded so its (large, growing) module graph — including the Tinuiti/Google/Custom
// ABCD feature catalog from bpm-types — is only fetched when a user navigates here, not
// eagerly on every page load via the NavBar-mounted app shell.
const CreativeMap = lazy(() =>
  import('@src/Pages/CreativeMap').then(m => ({ default: m.CreativeMap }))
);

// Lazy-loaded so this internal-tools page's module graph is only fetched when a user navigates
// here, not eagerly on every page load via the NavBar-mounted app shell. (jimp itself is deferred
// separately, via a dynamic import at its own use site in ImageUploader.tsx.)
const ImageUploader = lazy(() =>
  import('@src/Pages/ImageUploader').then(m => ({ default: m.ImageUploader }))
);

// Lazy-loaded so the hidden Agentic Platform section (prototype pages and their fixtures) only ships
// to the few people with `enableAgenticPlatform`, never in the main bundle.
const AgenticPlatform = lazy(() =>
  import('@src/Pages/AgenticPlatform').then(m => ({ default: m.AgenticPlatform }))
);

// Redirects Display/Audio-only clients' Creative Allocations / Order Status entries to the
// shared streaming/audio/display tool. Client routes are mounted under `<Route path=':company'>`
// (BpmRouter.tsx), so `to` must be prefixed with the current company segment (mirroring
// BpmRouter.tsx's `Navigate to={`/${company}`}`) rather than navigating to an absolute path.
// Also preserves any matched sub-path (e.g. a bookmarked tab link) via the wildcard route's `*`
// param, matching this file's own `RedirectPreservingSubpath` convention in location-utils.tsx.
const CompanyScopedRedirect = ({ to }: { to: string }) => {
  const company = useLocationCompany();
  const { '*': suffix } = useParams();
  return <Navigate to={`/${company}/${to}${suffix ? `/${suffix}` : ''}`} replace />;
};

const RedirectToStreamingCreatives = () => <CompanyScopedRedirect to='streaming/creatives' />;
const RedirectToStreamingStatus = () => <CompanyScopedRedirect to='streaming/status' />;

const createChannelSubPages = (
  pageID: string,
  overviewPage: ComponentType,
  metricsTablePage: ComponentType,
  deliveryPage: ComponentType,
  deliveryLabel = 'Delivery'
): BpmLocation[] => [
  {
    key: 'overview',
    prettyName: 'Overview',
    pageComponent: overviewPage,
    type: LocationType.Client,
    roleRequired: Role.EXTERNAL,
    testCompanyParams: {
      channel: pageID,
      pageID
    }
  },
  {
    key: 'delivery',
    prettyName: deliveryLabel,
    pageComponent: deliveryPage,
    type: LocationType.Client,
    roleRequired: Role.EXTERNAL,
    testCompanyParams: {
      channel: pageID,
      pageID
    }
  },
  {
    key: 'metrics-table',
    prettyName: 'Metrics Table',
    pageComponent: metricsTablePage,
    type: LocationType.Client,
    roleRequired: Role.EXTERNAL,
    testCompanyParams: {
      channel: pageID,
      pageID
    }
  }
];

export const NAV_LOCATIONS: NavGroup[] = [
  {
    key: NavGroupKey.CHANNELS,
    prettyName: 'Channels',
    icon: HiOutlineDocumentReport,
    items: [
      {
        key: 'dashboard',
        prettyName: 'Dashboards',
        pageComponent: DashboardPage,
        type: LocationType.Client,
        icon: <RiGridLine />,
        experiment: 'enableDashboardBuilder',
        experimentExternalOnly: true
      },
      {
        key: 'charts',
        prettyName: 'Charts',
        pageComponent: ChartsPage,
        type: LocationType.Client,
        icon: <RiGridLine />,
        experiment: 'enableDashboardBuilder',
        experimentExternalOnly: true
      },
      {
        key: 'cross-channel',
        prettyName: 'Cross-Channel',
        type: LocationType.Client,
        icon: <CrossChannelIcon />,
        subNavs: [
          ...createChannelSubPages(
            CROSS_CHANNEL,
            CrossChannel,
            CrossChannel,
            CrossChannel,
            'Delivery & Performance'
          ),
          {
            key: 'total-business',
            prettyName: 'Total Business',
            pageComponent: CrossChannel,
            type: LocationType.Client,
            roleRequired: Role.EXTERNAL,
            testCompanyParams: {
              channel: CROSS_CHANNEL,
              pageID: CROSS_CHANNEL
            }
          }
        ]
      },
      {
        key: 'tvad-cross-channel',
        prettyName: 'TVAD Cross-Channel',
        pageComponent: PlaceholderPage,
        type: LocationType.Client,
        icon: <TVADCrossChannel />,
        experiment: 'showLegacyTVADPages'
      },
      {
        key: 'commerce',
        prettyName: 'Commerce',
        type: LocationType.Client,
        icon: <HiOutlineShoppingCart />,
        mediaType: COMMERCE,
        subNavs: [
          ...createChannelSubPages(
            COMMERCE,
            CommerceSingleChannel,
            CommerceSingleChannel,
            CommerceSingleChannel
          ),
          {
            key: 'amc-insights',
            prettyName: 'AMC Insights',
            // bpm-frontend owns the AMC Insights shell at the top-level `/amc-insights` path; the
            // gateway routes only `amc-insights/category-pathing` here. Override the Commerce-nested
            // path so this app serves that tab at the same URL bpm's tab bar links to.
            fullPath: '/amc-insights',
            pageComponent: AmcInsights,
            type: LocationType.Client,
            roleRequired: Role.EXTERNAL
            // No experiment gate here — AMC Insights should show in the navbar like bpm does (by
            // role). Only the Category Pathing tab/content is gated by `enableAmcPathingAnalysis`,
            // inside AmcInsights.
          },
          {
            key: 'retail-ops-channels',
            prettyName: 'Retail Ops Channels',
            pageComponent: RetailOpsChannels,
            type: LocationType.Client,
            fullPath: '/retail-ops-channels'
          },
          {
            key: 'alexa-visibility',
            prettyName: 'Alexa Visibility',
            pageComponent: AlexaVisibility,
            type: LocationType.Client,
            // SOAR (Share of Agent Recommendations): a tracker for Amazon's
            // Alexa/Rufus shopping-assistant visibility. Internal-only for now.
            roleRequired: Role.INTERNAL
          },
          {
            key: INTERNAL_TOOLS_TERTIARY_KEY,
            prettyName: 'Internal Commerce',
            tertiaryNavs: [
              {
                type: LocationType.Client,
                navs: [
                  {
                    key: 'commerce-ad-ops',
                    prettyName: 'AdOps Tools',
                    pageComponent: CommerceAdOps,
                    fullPath: '/adops/commerce',
                    // Keeps the pre-rename URL working for anyone with it bookmarked.
                    redirects: ['commerce-tools'],
                    roleRequired: Role.INTERNAL
                  },
                  {
                    // Hidden internal comparison route: the Category Pathing dashboard on the
                    // static demo dataset, alongside the live version at /amc-insights/category-pathing.
                    // Reuses the legacy `commerce/amc-experiment` path (already routed to tinuiti in
                    // the prod gateway). Internal-only (roleRequired 1) so clients never see it.
                    key: 'amc-experiment',
                    prettyName: 'Category Pathing (Demo)',
                    pageComponent: CategoryPathingDemo,
                    fullPath: '/commerce/amc-experiment',
                    roleRequired: Role.INTERNAL
                  }
                ]
              },
              {
                type: LocationType.Global,
                navs: [
                  {
                    key: 'commerce-scraper',
                    prettyName: 'Commerce Scraper',
                    pageComponent: CommerceScraper,
                    fullPath: '/commerce-scraper',
                    roleRequired: Role.INTERNAL
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        key: 'commerce-ops',
        prettyName: 'Commerce Ops',
        type: LocationType.Client,
        icon: <MdOutlineLocalShipping />,
        mediaType: COMMERCE_OPS,
        mediaTypeGatesNavOnly: true,
        subNavs: [
          {
            key: 'overview',
            prettyName: 'Overview',
            pageComponent: CommerceOps,
            type: LocationType.Client,
            roleRequired: Role.EXTERNAL
          },
          {
            key: 'inventory',
            prettyName: 'Inventory',
            pageComponent: CommerceOps,
            type: LocationType.Client,
            roleRequired: Role.EXTERNAL
          },
          {
            key: 'keywords-and-traffic',
            prettyName: 'Keywords/Traffic',
            pageComponent: CommerceOps,
            type: LocationType.Client,
            roleRequired: Role.EXTERNAL
          },
          {
            key: 'buybox',
            prettyName: 'Buybox',
            pageComponent: CommerceOps,
            type: LocationType.Client,
            roleRequired: Role.EXTERNAL
          }
        ]
      },
      {
        key: 'display',
        prettyName: 'Display',
        type: LocationType.Client,
        icon: <MdOutlineAdsClick />,
        mediaType: DISPLAY,
        subNavs: [
          ...createChannelSubPages(
            DISPLAY,
            DisplaySingleChannel,
            DisplaySingleChannel,
            DisplaySingleChannel
          ),
          {
            key: INTERNAL_TOOLS_TERTIARY_KEY,
            prettyName: 'Internal Display',
            tertiaryNavs: [
              {
                type: LocationType.Client,
                navs: [
                  {
                    key: 'creatives',
                    prettyName: 'Creative Allocations',
                    // Display-only clients have no separate Creative Allocations page -- this
                    // links out to the shared streaming/audio/display tool at /streaming/creatives.
                    pageComponent: RedirectToStreamingCreatives,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'status',
                    prettyName: 'Order Status',
                    // Same as 'creatives' above -- links out to the shared /streaming/status tool.
                    pageComponent: RedirectToStreamingStatus,
                    roleRequired: Role.INTERNAL
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        key: 'custom',
        prettyName: 'Custom',
        type: LocationType.Client,
        icon: <RiMagicLine />,
        showWhenCustomDashboards: true,
        // subNavs is populated dynamically per company from custom_dashboards —
        // see buildCustomDashboardSubNavs in location-utils.tsx.
        subNavs: []
      },
      {
        key: 'linear',
        prettyName: 'Linear TV',
        type: LocationType.Client,
        icon: <RiTvLine />,
        mediaType: LINEAR,
        subNavs: [
          ...createChannelSubPages(
            LINEAR,
            LinearSingleChannel,
            LinearSingleChannel,
            LinearSingleChannel
          ),
          {
            key: 'spike',
            prettyName: 'Spike Chart',
            pageComponent: SpikeChart,
            type: LocationType.Client,
            roleRequired: Role.EXTERNAL,
            testCompanyParams: {
              channel: LINEAR,
              pageID: LINEAR
            }
          },
          {
            key: INTERNAL_TOOLS_TERTIARY_KEY,
            prettyName: 'Internal-Only Linear TV',
            tertiaryNavs: [
              {
                type: LocationType.Client,
                navs: [
                  {
                    key: 'linear-buying',
                    prettyName: 'Linear Buying',
                    pageComponent: LinearBuying,
                    fullPath: '/linear/buying',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'diagnostics',
                    prettyName: 'ML Diagnostics',
                    pageComponent: LinearMLDiagnostics,
                    fullPath: '/linear/diagnostics',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'linear-optimizations',
                    prettyName: 'Optimizations',
                    pageComponent: LinearOptimizations,
                    fullPath: '/linear/optimizations',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'orders',
                    prettyName: 'Orders',
                    pageComponent: LinearOrders,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'linear-plans',
                    prettyName: 'Plans',
                    pageComponent: LinearPlans,
                    fullPath: '/linear/plans',
                    roleRequired: Role.INTERNAL
                  }
                ]
              },
              {
                type: LocationType.Global,
                navs: [
                  {
                    key: 'assumptions',
                    prettyName: 'Clearance Assumptions',
                    pageComponent: PlaceholderPage,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'linear-cpms',
                    prettyName: 'CPMs',
                    pageComponent: LinearCpms,
                    fullPath: '/linear/cpms',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'linear-rates-comparisons',
                    prettyName: 'Rates Comparisons',
                    pageComponent: PlaceholderPage,
                    fullPath: '/linear/rates/comparisons',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'linear-pacing',
                    prettyName: 'Pacing',
                    pageComponent: LinearPacing,
                    fullPath: '/pacing/linear',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'credit-memos',
                    prettyName: 'Credit Memos',
                    pageComponent: CreditMemos,
                    fullPath: '/credit-memos',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'linear-ad-ops',
                    prettyName: 'AdOps Tools',
                    pageComponent: LinearAdOps,
                    fullPath: '/adops/linear',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'icon-local-mappings',
                    prettyName: 'ICON Local Linear Mappings',
                    pageComponent: IconLocalLinearMappings,
                    fullPath: '/linear/icon-local-mappings',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'constraints',
                    prettyName: 'Global Constraints',
                    pageComponent: LinearConstraints,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'assignments',
                    prettyName: 'Buying Assignments',
                    pageComponent: LinearBuyingAssignments,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'linear-networks',
                    prettyName: 'Networks',
                    pageComponent: LinearNetworks,
                    fullPath: '/linear/networks',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'logs-tracker',
                    prettyName: 'Logs Tracker',
                    pageComponent: LogsTracker,
                    fullPath: '/logs-tracker',
                    // Keeps the old split URLs working: /logs/pre -> /logs-tracker/pre.
                    redirects: ['logs'],
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'process-post-logs',
                    prettyName: 'Post Logs Processing',
                    pageComponent: ProcessLogs,
                    fullPath: '/process',
                    roleRequired: Role.INTERNAL
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        key: 'programmatic',
        prettyName: 'Programmatic',
        type: LocationType.Client,
        icon: <MdOutlineCampaign />,
        mediaType: PROGRAMMATIC,
        subNavs: createChannelSubPages(
          PROGRAMMATIC,
          ProgrammaticSingleChannel,
          ProgrammaticSingleChannel,
          ProgrammaticSingleChannel
        )
      },
      {
        key: 'radio',
        prettyName: 'Radio',
        type: LocationType.Client,
        icon: <FiRadio />,
        mediaType: RADIO,
        subNavs: [
          ...createChannelSubPages(
            RADIO,
            RadioSingleChannel,
            RadioSingleChannel,
            RadioSingleChannel
          ),
          {
            key: INTERNAL_TOOLS_TERTIARY_KEY,
            prettyName: 'Internal Radio',
            tertiaryNavs: [
              {
                type: LocationType.Client,
                navs: [
                  {
                    key: 'radio-buying',
                    prettyName: 'Radio Buying',
                    pageComponent: LinearBuying,
                    fullPath: '/radio/buying',
                    roleRequired: Role.INTERNAL,
                    experiment: 'enableRadioBuying',
                    channel: RADIO
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        key: 'search-shopping',
        prettyName: 'Search & Shopping',
        type: LocationType.Client,
        icon: <TbShoppingCartSearch />,
        mediaType: SEARCHSHOPPING,
        subNavs: [
          ...createChannelSubPages(
            SEARCHSHOPPING,
            SearchShoppingSingleChannel,
            SearchShoppingSingleChannel,
            SearchShoppingSingleChannel
          ),
          {
            key: 'adcopy-ai',
            prettyName: 'AdCopy AI',
            pageComponent: CopyTiger,
            type: LocationType.Client,
            // Open to client users for run review; CopyTiger gates its other tabs to internal users.
            roleRequired: Role.EXTERNAL,
            fullPath: '/adcopy-ai'
          }
        ]
      },
      {
        key: 'social',
        prettyName: 'Social',
        type: LocationType.Client,
        icon: <BiLike />,
        mediaType: SOCIAL,
        subNavs: [
          ...createChannelSubPages(
            SOCIAL,
            SocialSingleChannel,
            SocialSingleChannel,
            SocialSingleChannel
          ),
          {
            key: 'meta-signal-dashboard',
            prettyName: 'Meta Signal Dashboard',
            pageComponent: SignalDashboard,
            type: LocationType.Client,
            roleRequired: Role.INTERNAL_RESTRICTED,
            experiment: 'enableMetaSignalDashboard'
          },
          {
            key: 'meta-lift-study',
            prettyName: 'Meta Lift Study',
            pageComponent: PlaceholderPage,
            type: LocationType.Client,
            roleRequired: Role.EXTERNAL,
            fullPath: '/meta-lift-study/create'
          },
          {
            key: 'meta-creative-health-dashboard',
            prettyName: 'Meta Creative Health Dashboard',
            pageComponent: MetaFatigueInsights,
            type: LocationType.Client,
            roleRequired: Role.INTERNAL
          },
          {
            key: 'tiktokshop-auth',
            prettyName: 'TikTok Shop Auth',
            pageComponent: TikTokShopAuth,
            type: LocationType.Client,
            fullPath: '/tiktokshop-auth',
            roleRequired: Role.INTERNAL,
            // Skips the Social media-type gate for the route, so it resolves for every company.
            hideFromNav: true
          }
        ]
      },
      {
        key: 'streaming',
        prettyName: 'Streaming TV',
        type: LocationType.Client,
        icon: <FiCast />,
        mediaType: STREAMING,
        subNavs: [
          ...createChannelSubPages(
            STREAMING,
            StreamingSingleChannel,
            StreamingSingleChannel,
            StreamingSingleChannel
          ),
          {
            key: 'geo-response',
            prettyName: 'Geo Response',
            pageComponent: GeoResponse,
            type: LocationType.Client,
            roleRequired: Role.EXTERNAL
          },
          {
            key: INTERNAL_TOOLS_TERTIARY_KEY,
            prettyName: 'Internal Streaming TV',
            tertiaryNavs: [
              {
                type: LocationType.Client,
                navs: [
                  {
                    key: 'creatives',
                    prettyName: 'Creative Allocations',
                    pageComponent: StreamingCreatives,
                    roleRequired: Role.INTERNAL,
                    // Broadened so Display/Audio-only companies' own redirect entries
                    // (RedirectToStreamingCreatives under 'display'/'audio' below) resolve to a
                    // real route instead of 404ing — see pushDownMediaTypes in location-utils.tsx.
                    mediaType: [STREAMING, AUDIO, DISPLAY]
                  },
                  {
                    key: 'buying',
                    prettyName: 'Buying',
                    pageComponent: StreamingBuying,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'plan',
                    prettyName: 'Plans',
                    pageComponent: StreamingFlightPlan,
                    roleRequired: Role.INTERNAL,
                    experiment: 'enableStreamingPlansBuilder'
                  },
                  {
                    key: 'diagnostics',
                    prettyName: 'ML Diagnostics',
                    pageComponent: StreamingMLDiagnostics,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'optimizations',
                    prettyName: 'Optimizations',
                    pageComponent: StreamingOptimizations,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'status',
                    prettyName: 'Order Status',
                    pageComponent: StreamingOrderStatus,
                    roleRequired: Role.INTERNAL,
                    // Broadened so Display/Audio-only companies' own redirect entries
                    // (RedirectToStreamingStatus under 'display'/'audio' below) resolve to a
                    // real route instead of 404ing — see pushDownMediaTypes in location-utils.tsx.
                    mediaType: [STREAMING, AUDIO, DISPLAY]
                  },
                  {
                    key: 'agent-approvals',
                    prettyName: 'Agent Order Approvals',
                    pageComponent: AgentOrderApproval,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'reports',
                    prettyName: 'Reports',
                    pageComponent: StreamingReports,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'wizard',
                    prettyName: 'Wizard',
                    pageComponent: StreamingWizard,
                    roleRequired: Role.INTERNAL
                  }
                ]
              },
              {
                type: LocationType.Global,
                navs: [
                  {
                    key: 'streaming-active-streaming-media',
                    prettyName: 'Active Streaming Media (formerly Active OTT)',
                    pageComponent: ActiveOTT,
                    fullPath: '/active-streaming-media',
                    redirects: ['activeott'],
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'streaming-ad-ops',
                    prettyName: 'AdOps Tools',
                    pageComponent: StreamingAdOps,
                    fullPath: '/adops/streaming',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'streaming-validate-placement',
                    prettyName: 'Validate Placement',
                    pageComponent: StreamingValidatePlacement,
                    fullPath: '/adops/streaming/validate-placement',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'streaming-mappings',
                    prettyName: 'Unresolved Mappings',
                    pageComponent: StreamingUnresolvedMappings,
                    fullPath: '/adops/streaming/mappings',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'streaming-discrepancies',
                    prettyName: 'Discrepancies',
                    pageComponent: StreamingDiscrepancies,
                    fullPath: '/pacing/discrepancies',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'constraints',
                    prettyName: 'Global Constraints',
                    pageComponent: StreamingConstraints,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'streaming-networks',
                    prettyName: 'Networks',
                    pageComponent: StreamingNetworks,
                    fullPath: '/streaming/networks'
                    // No roleRequired: this route has no role gate (any authenticated user, not
                    // internal-only) — a placeholder here had tightened it to Role.INTERNAL,
                    // which would be a real access-restriction regression.
                  },
                  {
                    key: 'streaming-pacing',
                    prettyName: 'Pacing',
                    pageComponent: StreamingPacingPage,
                    fullPath: '/pacing/streaming',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'display-pacing',
                    prettyName: 'Display Pacing',
                    pageComponent: DisplayPacingPage,
                    fullPath: '/pacing/display',
                    roleRequired: Role.INTERNAL
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        key: 'audio',
        prettyName: 'Audio',
        type: LocationType.Client,
        icon: <CgHeadset />,
        mediaType: AUDIO,
        subNavs: [
          ...createChannelSubPages(
            AUDIO,
            AudioSingleChannel,
            AudioSingleChannel,
            AudioSingleChannel
          ),
          {
            key: 'geo-response',
            prettyName: 'Geo Response',
            pageComponent: GeoResponse,
            type: LocationType.Client,
            roleRequired: Role.EXTERNAL,
            channel: AUDIO
          },
          {
            key: INTERNAL_TOOLS_TERTIARY_KEY,
            prettyName: 'Internal Audio',
            tertiaryNavs: [
              {
                type: LocationType.Client,
                navs: [
                  {
                    key: 'optimizations',
                    prettyName: 'Audio Optimizations',
                    pageComponent: StreamingOptimizations,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'creatives',
                    prettyName: 'Creative Allocations',
                    // Audio-only clients have no separate Creative Allocations page -- this
                    // links out to the shared streaming/audio/display tool at /streaming/creatives.
                    pageComponent: RedirectToStreamingCreatives,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'status',
                    prettyName: 'Order Status',
                    // Same as 'creatives' above -- links out to the shared /streaming/status tool.
                    pageComponent: RedirectToStreamingStatus,
                    roleRequired: Role.INTERNAL
                  }
                ]
              },
              {
                type: LocationType.Global,
                navs: [
                  {
                    key: 'audio-active-streaming-media',
                    prettyName: 'Active Streaming Media (formerly Active OTT)',
                    pageComponent: ActiveOTT,
                    fullPath: '/active-streaming-media',
                    redirects: ['activeott'],
                    roleRequired: Role.INTERNAL
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        key: 'youtube',
        prettyName: 'Youtube',
        type: LocationType.Client,
        icon: <FiYoutube />,
        mediaType: YOUTUBE,
        subNavs: [
          ...createChannelSubPages(
            YOUTUBE,
            YoutubeSingleChannel,
            YoutubeSingleChannel,
            YoutubeSingleChannel
          ),
          {
            key: INTERNAL_TOOLS_TERTIARY_KEY,
            prettyName: 'Internal Youtube',
            tertiaryNavs: [
              {
                type: LocationType.Client,
                navs: [
                  {
                    key: 'planning',
                    prettyName: 'Planning',
                    pageComponent: YouTubePlanning,
                    roleRequired: Role.INTERNAL
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        key: 'email',
        prettyName: 'Email',
        type: LocationType.Client,
        icon: <MdEmail />,
        mediaType: EMAIL,
        subNavs: createChannelSubPages(
          EMAIL,
          EmailSingleChannel,
          EmailSingleChannel,
          EmailSingleChannel
        )
      }
    ]
  },
  {
    key: NavGroupKey.INSIGHTS,
    prettyName: 'Insights',
    icon: HiOutlineLightBulb,
    items: [
      {
        key: 'brand-health-metrics',
        prettyName: 'Brand Health',
        pageComponent: BrandHealthMetrics,
        type: LocationType.Client,
        icon: <RiHeartPulseLine />
      },
      {
        key: 'cross-channel-pacing',
        prettyName: 'Cross-Channel Pacing',
        pageComponent: Pacing,
        type: LocationType.Client,
        fullPath: '/pacing',
        icon: <AiFillSignal />,
        showWhenPacingClientFacing: true
      },
      {
        key: 'audience-and-planner',
        prettyName: 'Audience & Planner',
        pageComponent: Newton,
        type: LocationType.Client,
        icon: <RiDashboardLine />,
        experiment: 'enableNewton'
      },
      {
        key: 'competitive',
        prettyName: 'Competitive',
        type: LocationType.Client,
        icon: <RiTrophyLine />,
        subNavs: [
          {
            key: 'metrics',
            prettyName: 'Competitive Metrics',
            pageComponent: CompetitiveMetrics,
            type: LocationType.Client,
            roleRequired: Role.EXTERNAL
          },
          {
            key: 'spots',
            prettyName: 'Spot Details',
            pageComponent: CompetitiveSpots,
            type: LocationType.Client,
            roleRequired: Role.EXTERNAL
          }
        ]
      },
      {
        key: 'creatives',
        prettyName: 'Creatives',
        type: LocationType.Client,
        icon: <RiPaletteLine />,
        subNavs: [
          {
            key: 'creative-insights',
            prettyName: PAGE_NAMES.CREATIVE_INSIGHTS,
            pageComponent: CreativeInsights,
            type: LocationType.Client,
            fullPath: '/creative-insights',
            roleRequired: Role.EXTERNAL,
            experiment: 'creativeInsightsExternalCompanies',
            mediaType: LINEAR
          },
          {
            key: 'creative-insights-internal',
            prettyName: PAGE_NAMES.CREATIVE_INSIGHTS,
            pageComponent: CreativeInsights,
            type: LocationType.Client,
            fullPath: '/creative-insights',
            roleRequired: Role.INTERNAL_RESTRICTED,
            experiment: 'creativeInsightsInternalCompanies',
            mediaType: LINEAR
          },
          {
            key: 'creatives',
            prettyName: 'Creatives',
            pageComponent: CreativeMap,
            type: LocationType.Client,
            fullPath: '/creatives',
            roleRequired: Role.EXTERNAL,
            mediaType: [STREAMING, AUDIO, DISPLAY, LINEAR]
          }
        ]
      },
      {
        key: 'customer-insights',
        prettyName: 'Customer Insights',
        pageComponent: CustomerInsights,
        type: LocationType.Client,
        icon: <MdOutlinePersonPinCircle />,
        experiment: 'enableCustomerInsights'
      },
      {
        key: 'incrementality-playbook',
        prettyName: 'Incrementality Playbook',
        pageComponent: IncrementalityPlaybook,
        type: LocationType.Global,
        icon: <TiMortarBoard />
      },
      {
        key: 'insights-agent',
        prettyName: 'Insights Agent',
        pageComponent: InsightsAgent,
        type: LocationType.Client,
        icon: <RiRobot2Line />,
        experiment: 'enableInsightsAgent'
      },
      {
        // Full-page Oracle chat for any client
        key: 'oracle-chat',
        prettyName: 'Oracle Chat',
        pageComponent: OracleChat,
        type: LocationType.Client,
        roleRequired: Role.PARTNER,
        experiment: 'enableOracleChat',
        hideFromNav: true,
        icon: <RiRobot2Line />
      },
      {
        // Single-route Forrester demo tab. The prod gateway (bpm-frontend EKS) routes
        // /elevate/demo -> tinuiti-frontend. Internal-only; the nav entry is gated to
        // companies with `enableElevateDemo`, but the route still renders by URL
        // (experimentGatesNavOnly) so /elevate/demo works for the demo before the flag.
        key: 'demo',
        prettyName: 'Elevate Demo',
        pageComponent: ElevateDemo,
        type: LocationType.Client,
        roleRequired: Role.INTERNAL,
        experiment: 'enableElevateDemo',
        experimentGatesNavOnly: true,
        icon: <RiRobot2Line />
      },
      {
        key: 'agent-plan-buy',
        prettyName: 'Plan & Buy Agent',
        pageComponent: AgentPlanBuy,
        type: LocationType.Client,
        roleRequired: Role.INTERNAL,
        fullPath: '/agent/plan-buy',
        hideFromNav: true,
        icon: <RiRobot2Line />
      },
      {
        // Hidden build space for the joint Oracle / OS / ABMO team (DEV-25952). URL-only: never in
        // the nav. Unlike the Elevate demo above, the flag gates the route itself (no
        // experimentGatesNavOnly), so anyone without `enableAgenticPlatform` gets NotFound. The prod
        // gateway routes /:company/agentic-platform via bpm-frontend's client-page regex.
        key: AGENTIC_PLATFORM_KEY,
        prettyName: AGENTIC_PLATFORM_TITLE,
        pageComponent: AgenticPlatform,
        type: LocationType.Client,
        roleRequired: Role.INTERNAL,
        experiment: AGENTIC_PLATFORM_FLAG,
        hideFromNav: true,
        icon: <RiRobot2Line />
      },
      {
        key: 'reference',
        prettyName: 'Reference Docs',
        pageComponent: ReferenceDocs,
        type: LocationType.Global,
        icon: <MdOutlineFeed />
      },
      {
        key: 'product-roadmap',
        prettyName: 'Product Roadmap',
        pageComponent: ProductRoadmap,
        type: LocationType.Global,
        roleRequired: Role.INTERNAL,
        icon: <MdOutlineTimeline />
      }
    ]
  },
  {
    key: NavGroupKey.DATA_SCIENTIFIC,
    prettyName: 'Data Scientific',
    icon: MdOutlineScience,
    items: [
      {
        key: 'forecasting',
        prettyName: 'Forecasting',
        pageComponent: ForecastingPage,
        type: LocationType.Client,
        icon: <FiSun />,
        experiment: 'enableForecasting'
      },
      {
        key: 'scaling',
        prettyName: 'Scaling (Preview)',
        pageComponent: ScalingPage,
        type: LocationType.Global,
        icon: <MdAutoGraph />,
        experiment: 'enableScaling'
      },
      {
        key: 'hroas',
        prettyName: 'Holistic ROAS',
        pageComponent: HROAS,
        type: LocationType.Client,
        icon: <MdOutlineInsights />,
        companyExperiment: 'enableCompanyHROAS',
        roleRequired: 1,
        fullPath: '/hroas/*'
      },
      {
        key: 'mmm-model-results',
        prettyName: 'MMM Model Results',
        type: LocationType.Client,
        icon: <MdAutoGraph />,
        subNavs: [
          {
            key: 'brand-equity',
            prettyName: 'Brand Equity',
            pageComponent: BrandEquity,
            type: LocationType.Client,
            experiment: 'enableBrandEquityNavbar',
            experimentGatesNavOnly: true,
            roleRequired: Role.EXTERNAL,
            fullPath: '/brand-equity/*'
          },
          {
            key: 'dtc-mmm',
            prettyName: 'DTC MMM',
            pageComponent: RmmmDtc,
            type: LocationType.Client,
            experiment: 'enableMMMNavbarGui',
            experimentGatesNavOnly: true,
            showWhenDtcMmmRun: true,
            roleRequired: Role.EXTERNAL,
            fullPath: '/dtc-mmm/*'
          },
          {
            key: 'commerce-mmm',
            prettyName: 'Commerce MMM',
            pageComponent: RmmmCommerce,
            type: LocationType.Client,
            experiment: 'enableMMMNavbarGui',
            experimentGatesNavOnly: true,
            showWhenCommerceMmmRun: true,
            roleRequired: Role.EXTERNAL,
            fullPath: '/commerce-mmm/*'
          },
          {
            key: 'commerce-mmm_new',
            prettyName: 'Commerce MMM',
            pageComponent: CommerceMmm,
            type: LocationType.Client,
            experiment: 'enableCommerceMmm',
            hideFromNav: true,
            roleRequired: Role.EXTERNAL,
            fullPath: '/commerce-mmm_new'
          },
          {
            key: 'dtc-mmm_new',
            prettyName: 'DTC MMM',
            pageComponent: DtcCommerceMmm,
            type: LocationType.Client,
            experiment: 'enableDtcMmm',
            hideFromNav: true,
            fullPath: '/dtc-mmm_new'
          },
          {
            key: 'geo-mmm',
            prettyName: 'Geo MMM',
            pageComponent: GeoMMM,
            type: LocationType.Client,
            experiment: 'enableGeoMMM',
            experimentGatesNavOnly: true,
            roleRequired: Role.EXTERNAL,
            fullPath: '/geo-mmm/*'
          },
          {
            key: 'geo-mmm_new',
            prettyName: 'Geo MMM',
            pageComponent: GeoMmmNew,
            type: LocationType.Client,
            // Staff-only by direct link while it shows a single pinned run; gets its own
            // experiment flag when it opens up beyond internal users.
            hideFromNav: true,
            roleRequired: Role.INTERNAL,
            fullPath: '/geo-mmm_new'
          }
        ]
      },
      {
        key: 'mmm-feature-mapping',
        prettyName: 'MMM Feature Mapping',
        pageComponent: FeatureMapping,
        type: LocationType.Client,
        icon: <RiSettingsLine />,
        roleRequired: Role.INTERNAL,
        fullPath: '/mmm/feature-mapping'
      },
      {
        key: 'mmm-data-qa',
        prettyName: 'MMM Data QA',
        pageComponent: DataQA,
        type: LocationType.Client,
        icon: <MdOutlineFactCheck />,
        roleRequired: Role.INTERNAL,
        fullPath: '/mmm/data-qa'
      }
    ]
  },
  {
    key: NavGroupKey.INTERNAL_TOOLS,
    prettyName: 'Internal-Only Tools',
    icon: RiLockLine,
    items: [
      {
        key: '',
        prettyName: '',
        type: LocationType.Global,
        icon: <RiLockLine />,
        subNavs: [
          {
            key: '',
            prettyName: '',
            tertiaryNavs: [
              {
                sectionLabel: InternalToolsSectionKey.CLIENT_MANAGEMENT,
                type: LocationType.Client,
                navs: [
                  {
                    key: 'automated-alerting',
                    prettyName: 'Automated Alerting',
                    pageComponent: AnomalyDetection,
                    icon: <MdOutlineNotificationsActive />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'cross-client-benchmarking',
                    prettyName: 'Benchmarking',
                    pageComponent: XClientBenchmarking,
                    icon: <RiRulerLine />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'kpi-mapping',
                    prettyName: 'KPI Mapping',
                    pageComponent: KpiMapping,
                    icon: <RiFlowChart />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'segmentation-mapping',
                    prettyName: 'Segmentation Mapping',
                    pageComponent: SegmentationMapping,
                    icon: <RiLayoutMasonryLine />,
                    roleRequired: Role.INTERNAL_RESTRICTED
                  },
                  {
                    key: 'client-data-mapping',
                    prettyName: 'Client Data Mapping',
                    pageComponent: ClientDataMapping,
                    icon: <RiFlowChart />,
                    roleRequired: Role.INTERNAL,
                    experiment: 'enableClientOracleMapping'
                  },
                  {
                    key: 'oracle-config',
                    prettyName: 'Client Oracle Config',
                    pageComponent: OracleClientConfig,
                    icon: <RiFlowChart />,
                    roleRequired: Role.INTERNAL,
                    experiment: 'enableOracleClientConfig',
                    searchTabs: [{ key: ClientConfigTab.RECAP, prettyName: 'Client Recap' }]
                  },
                  {
                    key: 'cro-onboard',
                    prettyName: 'CRO Onboard',
                    pageComponent: CroOnboard,
                    icon: <AiOutlineRocket />,
                    roleRequired: Role.INTERNAL_RESTRICTED
                  },
                  {
                    key: 'sot-ga4-mapping',
                    prettyName: 'SOT/GA4 Mapping',
                    pageComponent: SotGa4MappingTool,
                    icon: <FiDatabase />,
                    // TODO(migrate): legacy bpm URL; final = /sot-ga4-mapping (drop fullPath)
                    fullPath: '/sot-ga4-mapping-tool',
                    roleRequired: Role.INTERNAL_RESTRICTED
                  },
                  {
                    key: 'edit-client',
                    prettyName: 'Edit Client',
                    pageComponent: ClientConfig,
                    icon: <FaUserEdit />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'properties',
                    prettyName: 'Properties',
                    pageComponent: PlaceholderPage,
                    icon: <RiSettingsLine />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'data-freshness',
                    prettyName: 'Data Freshness',
                    pageComponent: DataFreshness,
                    icon: <TiArrowRepeat />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'reporting',
                    prettyName: 'Reporting',
                    pageComponent: Reporting,
                    icon: <RiBarChartBoxLine />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'slide-generator',
                    prettyName: 'Slide Generator',
                    pageComponent: SlideGenerator,
                    icon: <RiSlideshow2Line />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'billing-automation',
                    prettyName: 'Billing Automation',
                    pageComponent: BillingAutomation,
                    icon: <RiRefund2Line />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'mobius-slides',
                    prettyName: 'Slides',
                    pageComponent: PlaceholderPage,
                    icon: <RiSlideshowLine />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'calendar-input',
                    prettyName: 'Calendar Inputs',
                    pageComponent: FiscalCalendarInputPage,
                    icon: <RiSlideshowLine />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'streaming-media-planner',
                    prettyName: 'Streaming Media Planner',
                    pageComponent: StreamingMediaPlanner,
                    icon: <RiGridLine />,
                    roleRequired: Role.INTERNAL,
                    experiment: 'enableStreamingPlansBuilder'
                  },
                  {
                    key: 'goal-intake',
                    prettyName: 'Goal Intake',
                    pageComponent: GoalIntake,
                    icon: <MdPlaylistAdd />,
                    // goal-intake-tool is the legacy bpm-frontend URL; budget-intake* are its older names.
                    redirects: ['goal-intake-tool', 'budget-intake', 'budget-intake-tool'],
                    // The retired Expected Bookings page.
                    retiredRedirects: ['bookings', 'expected-bookings'],
                    roleRequired: Role.INTERNAL
                  },
                  {
                    // Preview of the new Goal Intake (DEV-17365); reachable by URL only.
                    key: 'goal-intake-new',
                    prettyName: 'Goal Intake (new)',
                    pageComponent: GoalIntakeNew,
                    icon: <MdPlaylistAdd />,
                    hideFromNav: true,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'web-traffic-optimization',
                    prettyName: 'Web Traffic Optimization',
                    pageComponent: WebTrafficOptimization,
                    icon: <IoBrowsersOutline />,
                    redirects: ['wto'],
                    roleRequired: Role.INTERNAL_RESTRICTED
                  }
                ]
              },
              {
                sectionLabel: InternalToolsSectionKey.AUDIT,
                type: LocationType.Client,
                navs: [
                  {
                    // URL segment stays 'campaign-audit'. Renaming it to 'tvad-campaign-audit'
                    // (2026-09-09) put the page behind a Page Not Found on prod: the route entry was
                    // present and correct in the deployed bundle, and its `redirects` alias matched —
                    // which proves buildRoutes emitted routes for this location — yet the new path
                    // itself rendered NotFound. Root cause not established, so the URL is reverted
                    // rather than left broken; the DISPLAY name is "TVAD Campaign Audit" everywhere.
                    // Do not rename this key again without reproducing on a deployed environment
                    // first — it does not fail locally or in CI.
                    key: 'campaign-audit',
                    prettyName: 'TVAD Campaign Audit',
                    pageComponent: CampaignAudit,
                    icon: <MdOutlineFactCheck />,
                    // No experiment gate: access is by ROLE alone (V1 release, 2026-09-14). The
                    // former `enableCampaignAudit` flag only ever hid the NAV ENTRY — it carried
                    // experimentGatesNavOnly, and the route build passes
                    // treatNavOnlyExperimentsAsEnabled, so the URL itself was always reachable by
                    // any internal user. Dropping it makes the tool discoverable to the people who
                    // could already open it rather than granting anyone new access.
                    //
                    // roleRequired is now the ONLY gate on this entry — do not remove it. Without
                    // it the nav defaults to role 10 and every external client user gets the tool.
                    // Internal-only matches digital-audit and paid-search-audit in this section.
                    // The backend gates independently (every tvadcampaignaudits handler wraps in
                    // tinuitiInternalOnlyWrapper or tinuitiInternalCompany*Wrapper, all validating
                    // Role.INTERNAL), so this is defence in depth rather than the sole barrier.
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'paid-search-audit',
                    prettyName: 'Paid Search Audit',
                    pageComponent: PaidSearchAudit,
                    icon: <MdOutlineFactCheck />,
                    experiment: 'enablePaidSearchAudit',
                    // Internal-only (roleRequired 1) so clients never see it, matching digital-audit
                    // in this section. Without it the page defaults to role 10 (any user).
                    roleRequired: Role.INTERNAL
                  }
                ]
              },
              {
                sectionLabel: InternalToolsSectionKey.AUDIT,
                type: LocationType.Global,
                navs: [
                  {
                    key: 'digital-audit',
                    prettyName: 'Digital Audit',
                    pageComponent: DigitalAudit,
                    icon: <MdOutlineFactCheck />,
                    fullPath: '/audit/digital-audit',
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'google-ads-audit',
                    prettyName: 'Google Ads Audit',
                    pageComponent: GoogleAdsAudit,
                    icon: <MdOutlineFactCheck />,
                    fullPath: '/audit/google-ads-audit',
                    experiment: 'enableAuditAgent',
                    roleRequired: Role.INTERNAL
                  }
                ]
              },
              {
                sectionLabel: InternalToolsSectionKey.REPORTING,
                type: LocationType.Global,
                navs: [
                  {
                    key: 'query-exporter',
                    prettyName: 'Query Exporter',
                    pageComponent: QueryExporter,
                    icon: <IoTerminalOutline />,
                    roleRequired: Role.NOC
                  }
                ]
              },
              {
                sectionLabel: InternalToolsSectionKey.OPERATIONS,
                type: LocationType.Global,
                navs: [
                  {
                    key: 'add-new-client',
                    prettyName: 'Add New Client',
                    pageComponent: ClientConfig,
                    icon: <RiUserAddLine />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'amc-instances',
                    prettyName: 'AMC Instances',
                    pageComponent: AmcInstances,
                    icon: <RiDatabaseLine />,
                    roleRequired: 1,
                    experiment: 'enableAmcInstances'
                  },
                  {
                    key: 'client-profitability-survey',
                    prettyName: 'Client Profitability Survey',
                    pageComponent: ClientProfitabilitySurvey,
                    icon: <RiTimeLine />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'image-uploader',
                    prettyName: 'Image Uploader',
                    pageComponent: ImageUploader,
                    icon: <RiImageAddLine />,
                    redirects: ['cdn-uploader'],
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'finance',
                    prettyName: 'Finance',
                    pageComponent: Finance,
                    icon: <RiBillLine />,
                    roleRequired: Role.INTERNAL,
                    experiment: 'enableFinancePage'
                  },
                  {
                    key: 'invoicing',
                    prettyName: 'Invoicing',
                    pageComponent: Invoicing,
                    icon: <MdOutlineReceipt />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'user-admin',
                    prettyName: 'User Admin',
                    pageComponent: UserAdmin,
                    icon: <HiOutlineUsers />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'client-data-mapping-admin',
                    prettyName: 'Client Data Mapping (Global)',
                    pageComponent: GlobalDataMapping,
                    icon: <RiFlowChart />,
                    // Matches the backend's admin-only gate on the global list/reassign
                    // endpoints -- PRD's "Admins, P&T, and Darryl Harrell" access group doesn't
                    // map cleanly onto the existing role tiers yet, so this is pinned to role 0
                    // pending that decision.
                    roleRequired: Role.ADMIN,
                    experiment: 'enableClientOracleMapping'
                  },
                  {
                    key: 'cross-client-oracle-chat',
                    prettyName: 'Cross-Client Oracle Chat',
                    pageComponent: CrossClientOracleChat,
                    icon: <RiRobot2Line />,
                    roleRequired: Role.ADMIN,
                    experiment: 'enableCrossClientOracleChat'
                  },
                  {
                    key: 'slide-generator-admin',
                    prettyName: 'Slide Generator Admin',
                    pageComponent: SlideGeneratorAdmin,
                    icon: <RiSlideshow2Line />,
                    fullPath: '/slide-generator-admin',
                    roleRequired: Role.INTERNAL
                  }
                ]
              },
              {
                sectionLabel: InternalToolsSectionKey.MEDIA_TEAM_TOOLS,
                type: LocationType.Global,
                navs: [
                  {
                    key: 'admin',
                    prettyName: 'Admin',
                    pageComponent: Admin,
                    icon: <BsFillShieldLockFill />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'calendar',
                    prettyName: 'Calendar',
                    pageComponent: Calendar,
                    icon: <RiCalendarLine />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'device-breakout',
                    prettyName: 'Device Breakout',
                    pageComponent: DeviceBreakout,
                    icon: <RiDeviceLine />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'global-benchmarking',
                    prettyName: 'Global Benchmarking',
                    pageComponent: GlobalBenchmarking,
                    icon: <RiRulerLine />,
                    roleRequired: Role.INTERNAL,
                    experiment: 'enableGlobalBenchmarking'
                  }
                ]
              },
              {
                sectionLabel: InternalToolsSectionKey.DEVELOPER_TOOLS,
                type: LocationType.Global,
                navs: [
                  {
                    key: 'api-sentry',
                    prettyName: 'API Sentry',
                    pageComponent: ApiSentry,
                    icon: <MdOutlineNotificationsActive />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'batch-failures',
                    prettyName: 'Batch Failures',
                    pageComponent: BatchFailures,
                    icon: <VscDebug />,
                    roleRequired: Role.NOC
                  },
                  {
                    key: 'client-associations',
                    prettyName: 'Client Associations',
                    pageComponent: ClientAssociations,
                    icon: <RiGroupLine />,
                    roleRequired: Role.INTERNAL,
                    experiment: 'enableClientAssociations'
                  },
                  {
                    key: 'companies',
                    prettyName: 'Companies',
                    pageComponent: Companies,
                    icon: <RiBuilding2Line />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'site-monitoring',
                    prettyName: 'CRO Site Monitoring',
                    pageComponent: SiteMonitoring,
                    icon: <IoPulseSharp />,
                    roleRequired: Role.INTERNAL_RESTRICTED
                  },
                  {
                    key: 'dag-graphs',
                    prettyName: 'Dag Graphs',
                    pageComponent: DagGraphs,
                    icon: <RiNodeTree />,
                    roleRequired: Role.NOC
                  },
                  {
                    key: 'dag-start',
                    prettyName: 'Dag Start',
                    pageComponent: DagStart,
                    icon: <RiPlayLine />,
                    roleRequired: Role.NOC
                  },
                  {
                    key: 'dag-status',
                    prettyName: 'Dag Status',
                    pageComponent: DagStatus,
                    icon: <RiGitBranchLine />,
                    roleRequired: Role.NOC
                  },
                  {
                    key: 'data-connectors',
                    prettyName: 'Data Connector Tool',
                    pageComponent: DataConnectorTool,
                    icon: <RiPlugLine />,
                    redirects: ['dataconnectors', 'data_connectors'],
                    roleRequired: Role.NOC
                  },
                  {
                    key: 'feature-experiments',
                    prettyName: 'Feature Experiments',
                    pageComponent: FeatureExperiments,
                    icon: <RiToggleLine />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'feed-management',
                    prettyName: 'Feed Management',
                    pageComponent: FeedManagement,
                    roleRequired: Role.INTERNAL_RESTRICTED,
                    icon: <RiRssLine />
                  },
                  {
                    key: 'kpi-status',
                    prettyName: 'KPI Status',
                    pageComponent: KPIStatus,
                    icon: <FiActivity />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'kpi-setup',
                    prettyName: 'KPI Setup',
                    pageComponent: KpiSetup,
                    icon: <RiSettingsLine />,
                    redirects: ['kpisetup', 'kpi_setup'],
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'meta-hackathon',
                    prettyName: 'Meta Hackathon',
                    pageComponent: MetaHackathon,
                    icon: <RiTestTubeLine />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'shopify-connections',
                    prettyName: 'Shopify Connections',
                    pageComponent: ShopifyConnections,
                    icon: <RiStoreLine />,
                    roleRequired: Role.INTERNAL
                  },
                  {
                    key: 'system-health',
                    prettyName: 'System Health',
                    pageComponent: SystemHealth,
                    icon: <RiHeartPulseLine />,
                    roleRequired: Role.INTERNAL
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    isInternal: true
  },
  {
    key: NavGroupKey.ACTIVITY_FEED,
    prettyName: 'Activity Feed',
    icon: VscBellDot,
    isDirect: true,
    items: [
      {
        key: 'activity-feed',
        prettyName: 'Activity Feed',
        pageComponent: ActivityFeed,
        type: LocationType.Global,
        roleRequired: Role.PARTNER,
        experiment: 'enableActivityFeed'
      },
      {
        key: 'activity-feed',
        prettyName: 'Activity Feed',
        pageComponent: ActivityFeedClient,
        type: LocationType.Client,
        roleRequired: Role.PARTNER,
        experiment: 'enableActivityFeed'
      }
    ]
  }
];
